import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import classes from "./NavBar.module.css";

const NavBar = () => {
  const location = useLocation();

  const PATHNAMES = {
    HOME: "/",
    YOUR_DETAILS: "/yourdetails",
    RESULTS: "/results",
    TCS: "/T&Cs",
  };

  const [access, setAccess] = useState({
    home: false,
    yourDetails: false,
    results: false,
  });

  useEffect(() => {
    setAccess((prevAccess) => ({
      ...prevAccess,
      home: location.pathname === PATHNAMES.HOME || prevAccess.home,
      yourDetails:
        (location.pathname === PATHNAMES.YOUR_DETAILS && prevAccess.home) ||
        prevAccess.yourDetails,
      results:
        (location.pathname === PATHNAMES.RESULTS && prevAccess.yourDetails) ||
        prevAccess.results,
    }));
  }, [location.pathname]);

  const navLinks = useMemo(
    () => [
      {
        path: PATHNAMES.HOME,
        label: "Home",
        active: location.pathname === PATHNAMES.HOME,
        enabled: true,
      },
      {
        path: PATHNAMES.YOUR_DETAILS,
        label: "Your Details",
        active: location.pathname === PATHNAMES.YOUR_DETAILS,
        enabled: access.yourDetails,
      },
      {
        path: PATHNAMES.RESULTS,
        label: "Results",
        active: location.pathname === PATHNAMES.RESULTS,
        enabled: access.results,
      },
      {
        path: PATHNAMES.TCS,
        label: "T&Cs",
        active: location.pathname === PATHNAMES.TCS,
        enabled: true,
      },
    ],
    [location.pathname, access]
  );

  return (
    <nav className={classes.pageTabs}>
      {navLinks.map(({ path, label, active, enabled }) =>
        enabled ? (
          <Link
            key={path}
            className={`${classes.pageTab} ${
              active ? classes.pageTab_active : ""
            }`}
            to={path}
          >
            {label}
          </Link>
        ) : (
          <p
            key={path}
            className={`${classes.pageTab} ${classes.pageTab_inactive}`}
          >
            {label}
          </p>
        )
      )}
    </nav>
  );
};

export default NavBar;
